import type { BridgeRunResult } from './RequestModelingResponse';

export type BridgeChatRunner = (instruction: string) => Promise<BridgeRunResult>;

export class BridgeChatNotReadyError extends Error {
  constructor() {
    super('BridgeChatRunner is not registered');
    this.name = 'BridgeChatNotReadyError';
  }
}

let _runner: BridgeChatRunner | null = null;

export const MCPBridgeChatLocator = {
  register(runner: BridgeChatRunner): void {
    _runner = runner;
  },
  unregister(runner?: BridgeChatRunner): void {
    if (runner === undefined || _runner === runner) {
      _runner = null;
    }
  },
  // 未登録時は BridgeChatNotReadyError を throw する。
  // 呼び出し側での null チェックを不要にし、エラーハンドラで instanceof 判定できるようにするため。
  get(): BridgeChatRunner {
    if (_runner === null) {
      throw new BridgeChatNotReadyError();
    }
    return _runner;
  },
};
